import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Preloading from "../../../components/basics/Preloading";
import methods from "../../../services/utility";
import back from "../../../assets/images/icons/arrow-right2.svg";
import apiMethod from "../../../services/api-service";
import DeleteModal from "../../../components/deleteModal/DeleteModal";
import EditIcon from "../../../assets/images/icons/editIcon.svg";
import DeleteIcon from "../../../assets/images/icons/deleteIcon.svg";
import Paginations from "../../../components/paginaton/Paginations";

const OrderItems = () => {
  const { id, supplierId, restaurantId } = useParams();
  const [loading, setLoading] = useState(false);
  const [stepOrder, setStepOrder] = useState(1);
  const [gridData, setGridData] = useState([]);
  const [selectId, setSelectId] = useState(null);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productOrders, setProductOrders] = useState([]);
  const [unitMeasurements, setUnitMeasurements] = useState([]);
  const [productInfoOrder, setProductInfoOrder] = useState({
    code: "",
    id: "",
    inventories: [],
    latestFeePrice: "",
    title: "",
    totalInventory: "",
  });
  const [filterModel, setFilterModel] = useState({
    ProductName: "",
    Code: "",
    PurchaseOrderId: id,
    size: 10,
    part: 1,
    parts: 0,
    total: 0,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    productName: "",
    supplierName: "",
    productCode: "",
    amount: "",
    totalInventory: 0,
    latestFeePrice: 0,
    purchased: false,
    description: "",
    unitMeasurementId: 0,
    productId: 0,
    supplierId: supplierId,
    purchaseOrderId: id,
    inventories: null,
  });

  const [listProductOrders, setListProductOrders] = useState({
    restaurantId: restaurantId,
    purchaseOrderId: id,
    supplierId: supplierId,
    title: "",
    code: "",
    size: 20,
    part: 1,
  });

  const findProductOrder = async () => {
    setLoading(true);
    const resp = await apiMethod.findProductForOrder(
      listProductOrders.restaurantId,
      listProductOrders.purchaseOrderId,
      listProductOrders.title,
      listProductOrders.code,
      listProductOrders.size,
      listProductOrders.part
    );
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    setProductOrders(resp.data);
    setLoading(false);
  };

  const getGridData = async (customPart = null) => {
    const part = customPart ? customPart : filterModel.part;
    setLoading(true);
    const resp = await apiMethod.getPurchaseOrderItems(
      filterModel.PurchaseOrderId,
      filterModel.ProductName,
      filterModel.Code,
      filterModel.size,
      part
    );
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    filterModel.total = resp.total;
    filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
    filterModel.part = part;
    setFilterModel({ ...filterModel });
    setGridData(resp.data);
    setLoading(false);
  };

  const getUnitMeasurements = async () => {
    setLoading(true);
    const resp = await apiMethod.getRestaurantUnitMeasurements(
      restaurantId,
      "",
      100,
      1
    );
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    setUnitMeasurements(resp.data);
    setLoading(false);
  };

  useEffect(() => {
    findProductOrder();
    getGridData();
    getUnitMeasurements();
  }, []);

  const resetFilters = () => {
    filterModel.PurchaseOrderId = id;
    filterModel.Code = "";
    filterModel.ProductName = "";
    filterModel.part = 1;
    filterModel.size = 10;
    filterModel.parts = 0;
    filterModel.total = 0;
    setFilterModel({ ...filterModel });
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.productName = "";
    formModel.supplierName = "";
    formModel.productCode = "";
    formModel.amount = "";
    formModel.totalInventory = 0;
    formModel.latestFeePrice = 0;
    formModel.purchased = false;
    formModel.description = "";
    formModel.unitMeasurementId = 0;
    formModel.productId = 0;
    formModel.supplierId = supplierId;
    formModel.purchaseOrderId = id;
    formModel.inventories = null;
    setFormModel({ ...formModel });
  };

  const resetProductsOrder = () => {
    listProductOrders.restaurantId = restaurantId;
    listProductOrders.purchaseOrderId = id;
    listProductOrders.title = "";
    listProductOrders.code = "";
    listProductOrders.size = 20;
    listProductOrders.part = 1;
    setListProductOrders({ ...listProductOrders });
  };

  const closeOrderModal = () => {
    setShowOrderModal(false);
    setStepOrder(1);
  };

  const searchItemOrders = async () => {
    setLoading(true);
    await findProductOrder();
    setLoading(false);
  };

  const clearSearchOrders = async () => {
    resetProductsOrder();
    setLoading(true);
    await findProductOrder();
    setLoading(false);
  };

  const ChooseProduct = async (item) => {
    setLoading(true);
    const resp = await apiMethod.getProductInfoForPurchase(item.id);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    } else {
      setProductInfoOrder(resp.data);
      formModel.latestFeePrice = resp.data.latestFeePrice;
      formModel.totalInventory = resp.data.totalInventory;
      formModel.productName = resp.data.title;
      formModel.productCode = resp.data.code;
      formModel.productId = resp.data.id;
      formModel.inventories = resp.data.inventories;
      productInfoOrder.code = resp.data.code;
      productInfoOrder.title = resp.data.title;
      productInfoOrder.totalInventory = resp.data.totalInventory;
      productInfoOrder.id = resp.data.id;
      productInfoOrder.latestFeePrice = resp.data.latestFeePrice;
      productInfoOrder.inventories = resp.data.inventories;
      setFormModel({ ...formModel });
      setProductInfoOrder({ ...productInfoOrder });
      setLoading(false);
      setStepOrder(2);
    }
  };

  const validForm = () => {
    let errors = [];

    if (!formModel.amount) {
      errors.push("مقدار درخواستی کالا را وارد کنید");
    }

    if (!formModel.unitMeasurementId) {
      errors.push("واحد سنجش را انتخاب کنید");
    }

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const toggleInventorySelection = (item, selectedIndex) => {
    const updatedInventories = productInfoOrder?.inventories?.map(
      (inv, index) => {
        if (index === selectedIndex) {
          return { ...inv, selected: !inv.selected };
        }
        return inv;
      }
    );

    const totalInventory = updatedInventories
      .filter((inv) => inv.selected)
      .reduce((sum, inv) => sum + inv.inventory, 0);

    setFormModel({
      ...formModel,
      inventories: updatedInventories,
      totalInventory,
    });

    setProductInfoOrder({
      ...productInfoOrder,
      inventories: updatedInventories,
      totalInventory,
    });
  };

  const callPager = async (i) => {
    setLoading(true);
    setFilterModel({ ...filterModel, part: i });
    await getGridData(i);
    setLoading(false);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getPurchaseOrderItemInfo(id);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    formModel.id = resp.data.id;
    formModel.productId = resp.data.productId;
    formModel.description = resp.data.description;
    formModel.productName = resp.data.productName;
    formModel.productCode = resp.data.productCode;
    formModel.amount = resp.data.amount;
    formModel.unitMeasurementId = resp.data.unitMeasurementId;
    formModel.totalInventory = resp.data.totalInventory;
    formModel.latestFeePrice = resp.data.latestFeePrice;
    const parsedData = JSON.parse(resp.data.inventoryInquiryModel);
    setProductInfoOrder({
      ...productInfoOrder,
      title: resp.data.productName,
      inventories: parsedData,
    });
    setFormModel({ ...formModel });
    setStepOrder(2);
    setShowOrderModal(true);
    setLoading(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    resetForm();
  };

  const selectَItemToDelete = (item) => {
    setSelectId(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    const resp = await apiMethod.removePurchaseOrderItem(selectId.id);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    await getGridData();
    await findProductOrder();
    resetForm();
    setLoading(false);
    setShowDeleteModal(false);
  };

  const createItem = async () => {
    if (!validForm()) return false;
    setLoading(true);
    const resp = await apiMethod.createPurchaseOrderItem(formModel);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    resetForm();
    resetProductsOrder();
    await getGridData();
    await findProductOrder();
    setShowOrderModal(false);
    setStepOrder(1);
    setLoading(false);
  };

  const renderOrderItems = () => {
    return (
      <>
        {loading && <Preloading />}
        {
          <>
            <div className="d-none d-lg-block mb-3">
              <Link
                to={`/warehouse/${restaurantId}/purchaseOrder`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/warehouse/${restaurantId}/purchaseOrder`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                اقلام سفارش
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                اقلام سفارش
                <a
                  href={`/wareHouse/${restaurantId}/`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain mb-3">
              <div className="row align-items-end g-3">
                <div className="col-3">
                  <div>
                    <label htmlFor="searchInput" className="form-label">
                      عنوان
                    </label>
                    <input
                      id="searchInput"
                      className="form-control input-form"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.ProductName}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          ProductName: e.target.value,
                        });
                      }}
                      placeholder="جتسجو کنید..."
                    />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn-wrap search-btn"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      className="btn-wrap reset-btn"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
                <div className="col-7">
                  <div className="d-flex justify-content-end">
                    <button
                      class="btn btn-outline-purple custome-btn"
                      type="button"
                      onClick={() => setShowOrderModal(true)}
                    >
                      <span class="align-middle d-inline-block">ثبت اقلام</span>{" "}
                      <i class="bi bi-plus-circle align-middle"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="salemain">
              <span className="d-block text-start fw-bold fs-5">
                اقلام سفارش
              </span>
              <div className="table-responsive warhousetable">
                <table className="table table-md table-custom">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان کالا</th>
                      <th scope="col vertical-center">انبارها</th>
                      <th scope="col vertical-center">موجودی</th>
                      <th scope="col vertical-center">فی آخرین خرید</th>
                      <th scope="col vertical-center">مقدار درخواست</th>
                      <th scope="col vertical-center">واحد سنجش</th>
                      <th scope="col vertical-center">تامین کننده</th>
                      <th scope="col vertical-center">توضیحات</th>
                      <th scope="col vertical-center">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">{index + 1}</th>
                        <th>{item.productName}</th>
                        <th></th>
                        <th>{methods.addNumSeperator(item.totalInventory)}</th>
                        <th>{methods.addNumSeperator(item.latestFeePrice)}</th>
                        <th>{item.amount}</th>
                        <th>{item.unitMeasurementTitle}</th>
                        <th>{item.supplierName}</th>
                        <th>{item.description}</th>
                        <td className="d-flex align-items-center justify-content-center gap-2">
                          <button
                            onClick={() => editItem(item.id)}
                            className="button-action"
                            type="button"
                          >
                            <img src={EditIcon} alt="Image" />
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="button-action"
                            type="button"
                          >
                            <img src={DeleteIcon} alt="Image" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={filterModel.total}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const orderModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: "block" }}
        onClick={closeOrderModal}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">افزودن سفارش</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeOrderModal}
              ></button>
            </div>
            <div className="modal-body">
              {stepOrder === 1 ? (
                <div>
                  <div className="row g-1">
                    <div className="col-12 col-md-6 col-lg-4">
                      <label htmlFor="searchInput" className="form-label">
                        عنوان
                      </label>
                      <div className="hstack">
                        <input
                          id="searchInput"
                          className="form-control"
                          type="text"
                          aria-label="Add your item here..."
                          style={{ direction: "rtl", textAlign: "right" }}
                          value={listProductOrders.title}
                          onChange={(e) => {
                            setListProductOrders({
                              ...listProductOrders,
                              title: e.target.value,
                              part: 1,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className="col-2 d-flex align-items-end"
                      style={{ marginBottom: "4px" }}
                    >
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={searchItemOrders}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearchOrders}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="border rounded mt-4">
                    <p className="bg-light rounded-top p-3">
                      افزودن اقلام سفارش
                    </p>
                    <div className="table-responsive saletable m-3">
                      <table className="table table-striped table-md align-middle">
                        <thead className="">
                          <tr>
                            <th scope="col vertical-center" width="20px">
                              ردیف
                            </th>
                            <th scope="col vertical-center">عنوان</th>
                            <th scope="col vertical-center" width="50px">
                              عملیات
                            </th>
                          </tr>
                        </thead>
                        <tbody className="">
                          {productOrders.map((item, index) => (
                            <tr key={item.id}>
                              <th scope="row">{index + 1}</th>
                              <td>
                                <span>{item.title}</span>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-purple"
                                  onClick={() => ChooseProduct(item)}
                                >
                                  انتخاب
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="d-flex justify-content-end mb-3">
                    <button
                      className="btn btn-purple btn-sm"
                      onClick={() => {
                        setStepOrder(1);
                        resetForm();
                      }}
                    >
                      بازگشت
                    </button>
                  </div>
                  <div className="product-header">
                    <div className="product-header-icon">
                      <i className="bi bi-box-seam"></i>
                    </div>
                    <span className="product-header-text">عنوان کالا:</span>
                    <span className="product-header-title">
                      {productInfoOrder?.title}
                    </span>
                  </div>
                  <div className="row g-3 mb-3">
                    {productInfoOrder?.inventories?.map((item, index) => (
                      <div key={item.id} className="col-4">
                        <button
                          className={`w-100 inventories-wrapper ${
                            item.selected ? "active" : ""
                          }`}
                          onClick={() => toggleInventorySelection(item, index)}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <span style={{ color: "#666161" }}>
                              نام انبار :
                            </span>
                            <span className="fw-bold">
                              {item?.warehouseTitle}
                            </span>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <span style={{ color: "#666161" }}>کد انبار :</span>
                            <span className="fw-bold">
                              {item.warehouseCode}
                            </span>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <span style={{ color: "#666161" }}>کالا :</span>
                            <span className="fw-bold">{item.productName}</span>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <span style={{ color: "#666161" }}>کد کالا :</span>
                            <span className="fw-bold">{item.productCode}</span>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <span style={{ color: "#666161" }}>
                              موجودی انبار :
                            </span>
                            <span className="fw-bold">{item.inventory}</span>
                          </div>
                        </button>
                      </div>
                    ))}
                  </div>
                  <div className="row g-2 mb-3">
                    <div className="col-6">
                      <div className="product-info-box">
                        <span className="product-info-label">
                          مجموع موجودی کالا
                        </span>
                        <span className="product-info-value">
                          {methods.addNumSeperator(formModel.totalInventory)}
                        </span>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="product-info-box primary">
                        <span className="product-info-label">
                          مبلغ آخرین خرید
                        </span>
                        <span className="product-info-value">
                          {methods.addNumSeperator(formModel.latestFeePrice)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row g-2">
                    <div className="col-6">
                      <label htmlFor="amount" className="form-label">
                        مقدار درخواستی کالا
                      </label>
                      <div className="hstack">
                        <input
                          id="amount"
                          className="form-control"
                          type="text"
                          aria-label="Add your item here..."
                          style={{ direction: "rtl", textAlign: "right" }}
                          value={formModel.amount}
                          onChange={(e) => {
                            setFormModel({
                              ...formModel,
                              amount: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <label htmlFor="unitMeasurementId" className="form-label">
                        واحد سنجش
                      </label>
                      <select
                        id="unitMeasurementId"
                        className="form-select"
                        aria-label="Default select example"
                        value={formModel.unitMeasurementId}
                        onChange={(e) => {
                          formModel.unitMeasurementId = parseInt(
                            e.target.value
                          );
                          setFormModel({ ...formModel });
                        }}
                      >
                        <option value={0}>انتخاب کنید</option>
                        {unitMeasurements.map((item, index) => (
                          <option key={index} value={item.id}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12">
                      <label htmlFor="amount" className="form-label">
                        توضیحات
                      </label>
                      <div className="hstack">
                        <textarea
                          type="text"
                          className="form-control"
                          id="description"
                          name="description"
                          rows={3}
                          value={formModel.description}
                          onChange={(e) => {
                            setFormModel({
                              ...formModel,
                              description: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-end gap-3 mt-4">
                    <button
                      type="button"
                      class="btn custome-btn btn-link-purple"
                      onClick={closeOrderModal}
                    >
                      انصراف
                    </button>
                    <button
                      type="button"
                      class="btn custome-btn btn-purple"
                      onClick={createItem}
                    >
                      ثبت و ذخیره
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderOrderItems()}
      {showOrderModal && orderModal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"سفارش"}
        />
      )}
    </>
  );
};

export default OrderItems;
